<template>
  <v-snackbar v-bind="computedProps" v-on="$listeners" elevation="10">
    <div class="d-flex align-center">
      <span
        class="d-flex justify-center align-center rounded-circle pa-2 mr-2"
        :class="{ 'teal lighten-5': success, 'red lighten-4': error }"
      >
        <v-icon :color="success ? 'primaryColor' : 'error'" small>
          {{ success ? "fa-check" : "fa-exclamation-triangle" }}
        </v-icon>
      </span>
      <div>{{ actionMessage }}</div>
    </div>
    <template v-slot:action="{ attrs }">
      <v-btn small color="white" text v-bind="attrs" @click="onClose">
        <v-icon small>fa fa-times</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { VSnackbar } from "vuetify/lib";

export default {
  name: "SAlert",
  extends: VSnackbar,
  props: {
    message: {
      type: String,
    },
    success: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    actionType: {
      type: String,
      default: "normal",
    },
  },
  methods: {
    onClose() {
      return this.$emit("onClose");
    },
  },
  computed: {
    actionMessage() {
      let message = "";
      switch (this.actionType) {
        case "normal":
          message = this.message;
          break;
        case "create":
          message = `${this.message} est créé avec succès !`;
          break;
        case "update":
          message = `${this.message} est modifié avec succès`;
          break;
        case "delete":
          message = `${this.message} est supprimé avec succès`;
          break;
      }
      return message;
    },
    computedProps() {
      return {
        ...this.$props,
        color: this.success ? "primaryColor" : "error",
      };
    },
  },
};
</script>

<style></style>
